import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { System } from '@leverege/api-redux'
import { Pane } from '@leverege/ui-elements'

import { BreadcrumbActions } from '~/actions'
import EnumGroupScreen from './EnumGroupScreen'
import EnumItemScreen from './EnumItemScreen'

class SystemEnumScreen extends React.Component {

  constructor( props ) {
    super( props )
    const { match : { params : { systemId, projectId } } } = props
    this.systemId = systemId
    this.projectId = projectId
  }

  componentDidMount() {
    const { match : { params : { enumType } } } = this.props
    this.updateBreadcrumbs( enumType )
  }

  componentDidUpdate() {
    const { match : { params : { enumType } } } = this.props
    this.updateBreadcrumbs( enumType )
  }

  updateBreadcrumbs( enumType ) {
    const { dispatch } = this.props
    if ( enumType ) {
      dispatch( BreadcrumbActions.setBreadcrumbs( [
        { name : 'Resource Enums',
          link : `/project/${this.projectId}/system/${this.systemId}/resourceEnum` },
        { name : enumType }
      ] ) )
    } else {
      dispatch( BreadcrumbActions.setBreadcrumbs( [ { name : 'Resource Enums' } ] ) )
    }
  }

  onSelect = ( { data : enumType } ) => {
    const { history } = this.props
    this.updateBreadcrumbs( enumType )
    history.push( `/project/${this.projectId}/system/${this.systemId}/resourceEnum/${enumType}` )
  }

  render() {
    const { match : { params : { enumType } } } = this.props
    const baseActions = System( this.systemId )
    const groupActions = baseActions.resourceEnums()
    return (
      <Pane style={{ height : '100%', overflow : 'hidden' }} variant="view">
        <Route
          key={`/project/${this.projectId}/system/${this.systemId}/resourceEnum`}
          exact
          path={`/project/${this.projectId}/system/${this.systemId}/resourceEnum`}
          render={() => (
            <EnumGroupScreen
              onSelect={this.onSelect}
              actions={groupActions}
              canCreate={false}
              itemActions={type => baseActions.resourceEnum( type )}
              get={state => groupActions.getResourceEnums( state )} />
          )} />
        <Route
          key={`/project/${this.projectId}/system/${this.systemId}/resourceEnum/:enumType`}
          exact
          path={`/project/${this.projectId}/system/${this.systemId}/resourceEnum/:enumType`}
          render={() => (
            <EnumItemScreen
              enumType={enumType}
              actions={type => baseActions.resourceEnum( type )}
              get={state => baseActions.resourceEnum( enumType ).getResourceEnum( state )} />
          )} />
      </Pane>
    )
  }
}

export default connect()( SystemEnumScreen )
